import React, { Component } from "react";
import { Accordion, Card } from "react-bootstrap";
import NoDataFound from "../../component/NoDataFound";
import brochureFile from "../../assets/pdf/Project Monitoring Group Brochure.pdf";

class FAQs extends Component {
  state = {
    faqData: [
      {
        heading: "What type of projects does PMG provide assistance with?",
        // content:
        // "Any infrastructural or industrial project (domestic or foreign) with an investment of Rs. 500 Crores and above is eligible for PMG assistance. Projects with investment value below the aforementioned threshold can be uploaded by submitting a request to PMG after which it is subject to approval."
        content:
          "Any infrastructural or industrial project (domestic or foreign) with an investment of &#8377; 500 Cr. and above is eligible for PMG assistance."
      },
      {
        heading: "What is the role of PMG?",
        content:
          "PMG is an institutional mechanism that is tasked with facilitating issue resolution in projects that are facing delays or awaiting regulatory clearances with State and/or Central Ministries. If a company faces any bottlenecks in obtaining approvals from the Central and/or State Governments, it can upload the project and the issues accompanying it onto the PMG portal after creating an account and login credentials. After verification, PMG will take up the issues with the concerned authorities and facilitate expedited resolution."
      },
      // {
      //   heading: "What kind of issues are not taken up by PMG?",
      //   content:
      //     "Issues pending in a Court of law or Arbitrator(s), pertaining to usual business and financing risks, global macro-economic factors etc. are not taken up by PMG."
      // },
      {
        heading:
          "How much time does PMG take get issues resolved in the projects facing delays?",
        content:
          "Time taken to get issues resolved depends entirely upon the nature of the issue and the concerned agency. As soon as the project is uploaded by the project proponent onto the portal, it is subject to verification by PMG. After verification, the issues are taken up through inter-ministerial and state-level meetings, facilitated by PMG."
      },
      {
        heading: "Does PMG charge any fees for its services?",
        content:
          "PMG does not charge any fees for carrying out its functions. It is a government-instituted mechanism for issue resolution in large-scale projects across the country."
      },
      {
        heading: "In how many days PMG provides its services?",
        content:
          "Time taken to get issues resolved depends entirely upon the nature of the issue and the concerned agency. As soon as the project is uploaded by the project proponent onto the portal, it is subject to verification by PMG. After verification, the issues are taken up through inter-ministerial and state-level meetings, facilitated by PMG"
      },
      {
        heading: "Does PMG take up policy reforms with concerned authorities?",
        content:
          "Yes. PMG identifies and undertakes policy issues faced by a sector/sectors with the concerned authorities to enable simplification of obtaining clearances and approvals by project proponents."
      },
      {
        heading:
          "Is it necessary to visit PMG premises before uploading projects/issues on the PMG portal?",
        content:
          "No. The project proponent is not required to visit PMG premises before uploading a project or issues in a project."
      },
      {
        heading:
          "Do all issues that are taken up by PMG get resolved automatically?",
        content:
          "The role of PMG is to take up the issues causing project delays with the concerned Central and State agencies, expedite their decisions in a manner that is consistent with the statutory provisions and policy framework."
      },
      {
        heading:
          "What is the criteria for a project to qualify for expedited issue by PMG?",
        content:
          "Any project with an investment of &#8377; 500 Cr. or above and/or projects critical to national growth and development can be uploaded on the PMG portal for expedited issue resolution."
      },
      {
        heading:
          "Where can I find more information about PMG and status of my project?",
        content: `For more information, <a
            href="${brochureFile}"
            type="application/pdf"
            target="_blank"
            className="pdf-wrapper manual-wrapper"
        >
          click here
        </a>`
      }
      // {
      //   heading:
      //     "What are the key benefits for the department adopting the Online PMG Project Management System?",
      //   content:
      //     "It provides transparency and efficiency in the working environment, minimizes the processing delay, helps in timely disposal of important issues, enables one to work from anywhere, anytime, leads to a paperless working and provides ease and flexibility in the retrieval of various reports."
      // },
      // {
      //   heading: "Who is eligible to submit a project?",
      //   content:
      //     "Any Ministry/Department or any private entrepreneur can submit the stalled investment projects involving the investment of Rs. 500 Crore or more or if a project that is considered to be critical."
      // }
    ]
  };

  render() {
    const { faqData } = this.state;
    return (
      <div className="site-faq-wrapper" id="faq">
        <div className="small-container">
          {/*<h3>FAQ’s</h3>*/}
          <h2>Frequently Asked Questions (FAQs)</h2>
          {faqData && faqData.length ? (
            <Accordion defaultActiveKey={0} className="site-faq">
              {faqData &&
                faqData.map((faq, index) => {
                  return (
                    <Card key={`key-${index}`}>
                      <Accordion.Toggle as={Card.Header} eventKey={index}>
                        {faq.heading}
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={index}>
                        <Card.Body
                          dangerouslySetInnerHTML={{ __html: faq.content }}
                        />
                      </Accordion.Collapse>
                      <Accordion.Toggle
                        eventKey={index}
                        className="accordion-icon"
                      />
                    </Card>
                  );
                })}
            </Accordion>
          ) : (
            <NoDataFound />
          )}
        </div>
      </div>
    );
  }
}

export default FAQs;
